var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),(_vm.$route.query.id == 0)?_c('ArticalOne'):_vm._e(),(_vm.$route.query.id == 1)?_c('ArticalTow'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"data-v-fae5bece":"","src":"http://www.lvshouhotel.com/lvshouhotel/img_bg_news.png"}})])
}]

export { render, staticRenderFns }